import { Document, Page } from "@react-pdf/renderer";
import { getTenantStore } from "../../../stores/tenantStore";
import { styles } from "../ReactPdfStyles";
import PdfHeader from "../Reporting/PdfHeader";

interface ReportPdfLayoutProps {
	reportTitle: string;
	data: Record<string, any>;
	children: React.ReactNode;
}

function ReportPdfLayout({
	reportTitle,
	data,
	children,
}: ReportPdfLayoutProps) {
	const tenantList = getTenantStore().getTenantList();
	const tenant = tenantList.find(
		(tenant: any) => tenant.value === data.operator
	);
	const reportLogoUrl = tenant?.report_logo ?? tenant?.logo;

	return (
		<Document>
			<Page size="A4" style={styles.document} orientation="portrait">
				<PdfHeader
					reportTitle={reportTitle}
					data={{
						internal_report: data.internal_report,
						report_number: data.report_number,
						title: data.title,
					}}
					reportLogo={reportLogoUrl}
				/>

				{children}
			</Page>
		</Document>
	);
}

export default ReportPdfLayout;
